import { GET_MALLS, ADD_MALL, DELETE_MALL } from "../../actions/types";

const initalizeState = {
    malls: [],
    loading: true,
    error: {},
    updatedAt: new Date(),
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_MALLS:
            return {
                ...state,
                malls: payload.malls,
                loading: false,
            };
        case ADD_MALL:
            return {
                ...state,
                malls: [payload.mall, ...state.malls],
                loading: false,
                updatedAt: new Date(),
            };
        case DELETE_MALL:
            return {
                ...state,
                malls: state.malls.filter(mall => mall.id !== payload),
                loading: false,
                updatedAt: new Date(),
            };
        default:
            return state;
    }
}
